/* ── SmartPack Core - Order instructions controller (cart) ── */
(function () {
  'use strict';

  var READY_ATTR = 'data-sp-ins-ready';
  var SAVE_DEBOUNCE = 700;
  var STATUS_LINGER = 2500;

  var state = new WeakMap();

  function stateFor(root) {
    var s = state.get(root);
    if (!s) {
      s = { timer: null, clearTimer: null, dirty: false, inFlight: false, pending: false };
      state.set(root, s);
    }
    return s;
  }

  function cardOf(el) {
    return el && el.closest ? el.closest('[data-sp-ins]') : null;
  }

  /* ── Status line ── */

  function say(root, msg, isError, sticky) {
    var status = root.querySelector('[data-sp-ins-status]');
    if (!status) return;
    var s = stateFor(root);
    if (s.clearTimer) { clearTimeout(s.clearTimer); s.clearTimer = null; }
    status.textContent = msg || '';
    status.classList.toggle('sp-ins__status--err', !!isError);
    status.hidden = !msg;
    if (msg && !sticky) {
      s.clearTimer = setTimeout(function () {
        status.hidden = true;
        status.textContent = '';
      }, STATUS_LINGER);
    }
  }

  function collect(root) {
    var attrs = {};
    var fields = root.querySelectorAll('[data-sp-ins-key]');
    for (var i = 0; i < fields.length; i++) {
      var el = fields[i];
      var key = el.getAttribute('data-sp-ins-key');
      if (!key) continue;
      if (el.type === 'checkbox') {
        attrs[key] = el.checked ? (el.value || 'Yes') : '';
      } else {
        attrs[key] = (el.value || '').trim();
      }
    }
    return attrs;
  }

  function save(root) {
    var s = stateFor(root);
    if (s.timer) { clearTimeout(s.timer); s.timer = null; }
    s.dirty = false;

    if (s.inFlight) { s.pending = true; return; }
    s.inFlight = true;
    say(root, 'Saving...', false, true);

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/update.js'
      : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: collect(root) })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('save failed');
        return r.json();
      })
      .then(function () {
        if (!s.pending) {
          say(root, 'Saved');
          root.dispatchEvent(new CustomEvent('sp:instructions-saved', { bubbles: true }));
        }
      })
      .catch(function () {
        if (!s.pending) say(root, 'Could not save - check your connection.', true, true);
      })
      .then(function () {
        s.inFlight = false;
        if (s.pending) { s.pending = false; save(root); }
      });
  }

  function queueSave(root, immediate) {
    var s = stateFor(root);
    s.dirty = true;
    if (s.timer) { clearTimeout(s.timer); s.timer = null; }
    if (immediate) { save(root); return; }
    s.timer = setTimeout(function () { save(root); }, SAVE_DEBOUNCE);
  }

  function daysOut(value) {
    if (!value) return null;
    var parts = value.split('-');
    if (parts.length !== 3) return null;
    var target = new Date(+parts[0], +parts[1] - 1, +parts[2]);
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return Math.round((target - today) / 86400000);
  }

  function renderLead(root) {
    var dateEl = root.querySelector('[data-sp-ins-date]');
    var leadNote = root.querySelector('[data-sp-ins-leadnote]');
    if (!dateEl || !leadNote) return;

    var d = daysOut(dateEl.value);
    if (d === null) { leadNote.hidden = true; return; }

    var lo = parseInt(dateEl.dataset.leadMin, 10) || 3;
    var hi = parseInt(dateEl.dataset.leadMax, 10) || 5;
    var range = lo + '-' + hi + ' business days';

    if (d < 0) {
      leadNote.innerHTML = '<b>That date has passed.</b> Pick a date from today onward.';
    } else if (d <= hi) {
      leadNote.innerHTML = '<b>' + d + ' day' + (d === 1 ? '' : 's') + ' out</b> - production alone is ' + range +
        ', so this is tight. Add a note and we will tell you what is achievable before printing.';
    } else {
      leadNote.innerHTML = '<b>' + d + ' days out</b> - production is ' + range +
        ' plus transit, so this should land in time. If the date is firm, add a note and we will confirm before printing.';
    }
    leadNote.hidden = false;
  }

  function prepare(root) {
    if (!root || root.hasAttribute(READY_ATTR)) return;
    root.setAttribute(READY_ATTR, '');

    var dateEl = root.querySelector('[data-sp-ins-date]');
    if (dateEl) {
      var t = new Date();
      dateEl.min = [
        t.getFullYear(),
        String(t.getMonth() + 1).padStart(2, '0'),
        String(t.getDate()).padStart(2, '0')
      ].join('-');
    }

    renderLead(root);
    root.dispatchEvent(new CustomEvent('sp:instructions-ready', { bubbles: true }));

    if (root.hasAttribute('data-sp-ins-seed')) save(root);
  }

  function prepareAll() {
    var cards = document.querySelectorAll('[data-sp-ins]:not([' + READY_ATTR + '])');
    for (var i = 0; i < cards.length; i++) prepare(cards[i]);
  }

  document.addEventListener('input', function (e) {
    var el = e.target.closest && e.target.closest('[data-sp-ins-field]');
    if (!el || el.type === 'checkbox') return;
    var root = cardOf(el);
    if (!root) return;
    if (el.hasAttribute('data-sp-ins-date')) renderLead(root);
    queueSave(root, false);
  });

  document.addEventListener('change', function (e) {
    var el = e.target.closest && e.target.closest('[data-sp-ins-field]');
    if (!el) return;
    var root = cardOf(el);
    if (!root) return;
    if (el.type === 'checkbox') { queueSave(root, true); return; }
    if (el.hasAttribute('data-sp-ins-date')) renderLead(root);
    queueSave(root, true);
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sp-ins-clear]');
    if (!btn) return;
    var root = cardOf(btn);
    if (!root) return;
    e.preventDefault();

    var fields = root.querySelectorAll('[data-sp-ins-field]');
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].type === 'checkbox') fields[i].checked = false;
      else fields[i].value = '';
    }

    var seedNote = root.querySelector('[data-sp-ins-seednote]');
    if (seedNote) seedNote.hidden = true;
    root.removeAttribute('data-sp-ins-seed');

    renderLead(root);
    save(root);
  });

  document.addEventListener('focusout', function (e) {
    var el = e.target.closest && e.target.closest('[data-sp-ins-field]');
    if (!el || el.type === 'checkbox') return;
    var root = cardOf(el);
    if (!root) return;
    if (stateFor(root).dirty) save(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareAll);
  } else {
    prepareAll();
  }

  document.addEventListener('shopify:section:load', prepareAll);

  if (window.MutationObserver) {
    var scheduled = false;
    var flush = function () { scheduled = false; prepareAll(); };

    new MutationObserver(function (records) {
      if (scheduled) return;
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes && records[i].addedNodes.length) {
          scheduled = true;
          setTimeout(flush, 0);
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
